import { NavigationPreview, StepDialog } from '@all-manager/design-system-v2';
import { useOnboardingDialog } from './useOnboardingDialog';

const LABELS = {
  skip: 'Passer',
  previous: 'Précédent',
  next: 'Suivant',
  finish: "Découvrir l'espace",
  progress: (current: number, total: number) => `Étape ${current} sur ${total}`,
};

/** First-run tour of the space for members who consult it (readers, council members). */
export default function OnboardingDialog() {
  const hook = useOnboardingDialog();

  if (!hook.isVisible) {
    return null;
  }

  return (
    <StepDialog
      open={hook.isOpen}
      steps={hook.steps.map((step) => ({
        id: step.id,
        title: step.title,
        description: step.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>),
        points: step.points,
      }))}
      activeStep={hook.activeStep}
      onStepChange={hook.handleStepChange}
      onSkip={hook.handleSkip}
      onFinish={hook.handleFinish}
      labels={LABELS}
      visual={
        <NavigationPreview
          groups={hook.previewGroups.map((group) => ({
            title: group.title,
            items: group.destinations.map((destination) => ({
              id: destination.id,
              label: destination.label,
              icon: <destination.Icon />,
            })),
          }))}
          highlightedIds={hook.highlightedIds}
          caption={hook.previewCaption}
        />
      }
    />
  );
}
